var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{attrs:{"center":{
      lat: _vm.content.location.position.lat,
      lng: _vm.content.location.position.lng},"zoom":12}},[_c('GmapMarker',{key:_vm.index,attrs:{"position":_vm.google && new _vm.google.maps.LatLng(
      _vm.content.location.position.lat,
      _vm.content.location.position.lng)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }